import classNames from "classnames";
import { useTrackSearchFormInteraction } from "@/shared/lib/ube";
import { useCollapsibleViewContext } from "./CollapsibleViewContext";

type CollapsibleViewButtonLabels = {
    collapseLabel: string;
    showLabel: string;
};
interface CollapsibleViewButtonProps {
    labels: CollapsibleViewButtonLabels;
}

export const CollapsibleViewButton = ({ labels }: CollapsibleViewButtonProps) => {
    const { isCollapsed, setCollapsibleView } = useCollapsibleViewContext();
    const track = useTrackSearchFormInteraction();

    return (
        <button
            type="button"
            className={classNames("link iconAfter", {
                iconArrowSmallDownAfter: isCollapsed,
                iconArrowSmallUpAfter: !isCollapsed,
            })}
            onClick={() => {
                track({ action: isCollapsed ? "expand" : "collapse", objectName: "collapsible_view" });
                setCollapsibleView(!isCollapsed);
            }}
        >
            {isCollapsed ? labels.showLabel : labels.collapseLabel}
        </button>
    );
};
